export default {
  baseAPI: 'https://synsaude-prod.azurewebsites.net',
  //Prod
  PublicKeyPagarme: 'pk_67YydKijpixPAldP'
};
